import { UserRole } from '@/contexts/AuthContext';

/**
 * Check if a user has any role that allows policy creation
 */
export function canCreatePolicies(roles: UserRole[]): boolean {
  return roles.includes('creator') || roles.includes('admin');
}

/**
 * Check if a user has any role that allows policy editing
 */
export function canEditPolicies(roles: UserRole[]): boolean {
  return roles.includes('creator') || roles.includes('admin') || roles.includes('reviewer');
}

/**
 * Check if a user is a pure viewer (viewer role with no other permissions)
 */
export function isPureViewer(roles: UserRole[]): boolean {
  return roles.includes('viewer') && roles.length === 1;
}

/**
 * Check if a user can access AI Agent features
 * Viewers can use AI Agent but cannot create policies
 */
export function canUseAIAgent(roles: UserRole[]): boolean {
  return true; // All users can use AI Agent
}

/**
 * Check if a user can create policies via AI Agent
 */
export function canCreateViaAI(roles: UserRole[]): boolean {
  return canCreatePolicies(roles);
}

